import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import FormInput from '../../form/FormInput';
import FormSelect from '../../form/FormSelect';
import FormDatePicker from '../../form/FormDatePicker';
import ProfileImageUpload from './ProfileImageUpload';
import { customStyles } from '../../../utils/selectUtils';
const hasAdminToken = !!localStorage.getItem('adminToken');

const StepPersonalInfo = ({ control, errors, lookupOptions, profileImagePreview, handleImageChange, isWhatsappSame, handleWhatsappCheck, isPanRequired, isAadharRequired }) => (
    <div className="animate-fade-in">
        <Row>
            <Col md={3} className="text-center mb-4">
                <ProfileImageUpload preview={profileImagePreview} onChange={handleImageChange} />
            </Col>
            <Col md={9}>
                <div className="form-section-title mt-0">Identity & Contact</div>
                <Row>
                    <Col md={4}><FormInput name="fullName" label="Full Name" control={control} errors={errors} readOnly={!hasAdminToken} isRequired /></Col> 
                    <Col md={4}><FormInput name="email" label="Email" type="email" control={control} errors={errors} readOnly={!hasAdminToken} isRequired /></Col> 
                    <Col md={4}>
                        <FormInput name="mobileNumber" label="Mobile" control={control} errors={errors} readOnly={!hasAdminToken} isRequired />
                        <Form.Check type="checkbox" label="Use same for WhatsApp?" id="whatsapp-check" className="text-white small mt-1" checked={isWhatsappSame} onChange={handleWhatsappCheck} />
                    </Col>
                </Row>
                <Row>
                    <Col md={4}><FormInput name="alternateMobileNumber" label="Alt Mobile" control={control} errors={errors} /></Col>
                    <Col md={4}><FormSelect name="educationLevel" label="Education" control={control} errors={errors} options={lookupOptions.educationLevel} isRequired /></Col> 
                    <Col md={4}>
                        <Form.Group className="mb-4">
                            <Form.Label className="form-label">Talents <span className="text-danger">*</span></Form.Label> 
                            <Controller name="talents" control={control} render={({ field }) => (
                                <Select {...field} isMulti options={lookupOptions.talent} styles={customStyles} placeholder="Select Talents" />
                            )} />
                            {errors.talents && <div className="text-danger small mt-1">{errors.talents.message}</div>}
                        </Form.Group>
                    </Col>
                </Row>
                <div className="form-section-title">Demographics</div>
                <Row>
                    <Col md={3}><FormDatePicker name="dateOfBirth" label="Date of Birth" control={control} errors={errors}  /></Col>
                    <Col md={3}><FormSelect name="gender" label="Gender" control={control} errors={errors} options={lookupOptions.gender}  /></Col> 
                    <Col md={3}><FormSelect name="nationality" label="Nationality" control={control} errors={errors} options={lookupOptions.nationality}  /></Col> 
                    <Col md={3}><FormSelect name="specialCategory" label="Special Category" control={control} errors={errors} options={lookupOptions.specialCategory} /></Col> 
                    <Col md={3}><FormSelect name="countryOfResidence" label="Residence" control={control} errors={errors} options={lookupOptions.countryOfResidence}  /></Col>
                    <Col md={3}><FormSelect name="preferredCurrency" label="Currency" control={control} errors={errors} options={lookupOptions.preferredCurrency}  /></Col> 
                </Row>
                <div className="form-section-title">Biography & Identification</div>
                <FormInput name="aboutYourself" label="About Yourself" control={control} errors={errors} as="textarea"  />
                <Row>
                    <Col md={6}><FormInput name="panNumber" label="PAN Card" control={control} errors={errors} /></Col> 
                    <Col md={6}><FormInput name="aadharNumber" label="Aadhar Number" control={control} errors={errors}/></Col> 
                </Row>
            </Col>
        </Row>
    </div>
);

export default StepPersonalInfo;